module.exports = __webpack_public_path__ + "static/img/birdsbeasts_esp.e664fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/birdsbeasts_esp.png
// module id = 9hp5
// module chunks = 1